<div class="widget_box">
  <div class="widget_headers-wrapper" widgetHeaderHiding>
    @for (widget of widgets; track widget) {
      <widget-header
        [class.-active]="activeWidget === widget"
        [class.-is-widget-body-hovered]="isWidgetBodyHovered"
        (click)="setActiveWidget(widget)"
        [widget]="widget"
        [isGroupLinkingDisabled]="widgets.length === 1"
        page-widget-configurable
        page-widget-removable>
      </widget-header>
    }
  </div>
  <div class="widget_body"
    (mouseenter)="isWidgetBodyHovered = true"
    (mouseleave)="isWidgetBodyHovered = false"
    customScrollbar>
    <widget-body-renderer [widget]="activeWidget"></widget-body-renderer>
  </div>
</div>
